export { default as Icon } from './Icon';
export type { IconName } from './Icon';
